module.exports = __webpack_public_path__ + "745aff26ced73abe82803c20d580fede.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/australia_icon.png
// module id = 1227
// module chunks = 0